import { render, staticRenderFns } from "./OrderDrawer.vue?vue&type=template&id=74edc50a&lang=pug"
import script from "./OrderDrawer.vue?vue&type=script&lang=coffee"
export * from "./OrderDrawer.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports